import "./components/product-section";
import "./components/product-bis";
import "./components/new-product-gallery";
import "./components/new-product-description";
import "./components/product-series-carousel";
import "./components/product-recommendations";
import "./components/go-further";

// padding bottom for sticky add to cart on mobile
(() => {
  const stickyAddToCartMob = document.querySelector(".js-sticky-atc");

  document.body.style.setProperty(
    "--offsetPaddingBottom",
    stickyAddToCartMob.offsetHeight + "px"
  );
})();
